// ===== Packages =====

import React                from 'react';
import { Link }             from 'react-router-dom';

// ===== Services =====

import {
    detectTouchDevice,
    getTouchMouseEventHandlers,
}                           from '../../services';

// ===== Constants =====

import {
    HOVER_TARGET_CLASSNAME,
}                           from '../../constants/generalConstants';

// ===== Styles =====

import {
    Container,
}                           from './styles';

MenuButton.defaultProps = {
    route: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHoverEnter: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHoverLeave: undefined,
};
interface Props {
    route?: string,
    customCursorActive: boolean,
    width: number,
    height: number,
    isVisible: boolean,
    disabled: boolean,
    margin: number,
    withTransition: boolean,
    withDelay: boolean,
    translateDuration: number,
    translateDelay: number,
    offsetDelay: number,
    onClick?: (event: React.MouseEvent) => void,
    onHoverEnter?: (event: React.MouseEvent | React.TouchEvent) => void,
    onHoverLeave?: (event: React.MouseEvent | React.TouchEvent) => void,
    children: React.ReactNode
}
function MenuButton({
    route,
    customCursorActive,
    width,
    height,
    isVisible,
    disabled,
    margin,
    withTransition,
    withDelay,
    translateDuration,
    translateDelay,
    offsetDelay,
    onClick,
    onHoverEnter,
    onHoverLeave,
    children,
}: Props): JSX.Element {
    const button = (
        <Container
            {...(onHoverEnter || onHoverLeave ? { className: HOVER_TARGET_CLASSNAME } : {})}
            customCursorActive={customCursorActive}
            width={width}
            height={height}
            isVisible={isVisible}
            detectTouchDevice={detectTouchDevice(document)}
            disabled={disabled}
            withTransition={withTransition}
            withDelay={withDelay}
            offsetDelay={offsetDelay}
            translateDuration={translateDuration}
            translateDelay={translateDelay}
            margin={margin}
            {...(onClick ? { onClick } : {})}
            {...getTouchMouseEventHandlers({
                onMouseEnter: onHoverEnter,
                onMouseLeave: onHoverLeave,
            })}
        >
            {children}
        </Container>
    );

    if (route) {
        return (
            <Link to={`/${route}`}>
                {button}
            </Link>
        );
    }

    return button;
}

export default MenuButton;
